import styled from "styled-components";

export const ChartWrapper = styled.div`
    height: 350px;
`;